module.exports = __webpack_public_path__ + "img/pdf_bg_results_3.6364329b.png";